/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_TrailInputs */

const cs_gdpr_trail = /** @type {(inputs: Gdpr_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historie (audit)`)
};

const en_gdpr_trail = /** @type {(inputs: Gdpr_TrailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History (audit)`)
};

/**
* | output |
* | --- |
* | "History (audit)" |
*
* @param {Gdpr_TrailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_trail = /** @type {((inputs?: Gdpr_TrailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_TrailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_trail(inputs)
	return cs_gdpr_trail(inputs)
});